import React, {useEffect, useMemo, useState} from 'react'
import PropTypes from 'prop-types'
import {GroupBox} from "./groupbox";
import * as my from './MyForm'
import styled from "styled-components";
import {IconPlaceCircle} from "../../modals/modal.info";

const RadioIcon = () => <>
	<my.RadioIcon data-radio-icon data-checked data-hover>
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill="#1675B1"/>
			<rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="#1675B1"/>
			<circle cx="8" cy="8" r="3" fill="white"/>
		</svg>
	</my.RadioIcon>
	<my.RadioIcon data-radio-icon data-checked>
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill="#32A0E5"/>
			<rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="#32A0E5"/>
			<circle cx="8" cy="8" r="3" fill="white"/>
		</svg>
	</my.RadioIcon>
	<my.RadioIcon data-radio-icon data-hover>
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="16" height="16" rx="8" fill="#32A0E5" fillOpacity="0.1"/>
			<rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="#32A0E5" strokeOpacity="0.2"/>
		</svg>
	</my.RadioIcon>
	<my.RadioIcon data-radio-icon >
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="16" height="16" rx="8" fill="#EEEEEE" fillOpacity="0.03"/>
			<rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="#32A0E5" strokeOpacity="0.2"/>
		</svg>
	</my.RadioIcon>
</>

export const Radiobox = ({
	className = '',
	inputRef = false,
	inline = false,
	label = 'Label',
	name = '',
	value,
	defaultValue = false,
	hint = '',
	errorMessage = '',
	validMessage = '',
	...rest
}) => {
	const id = `radiobox_${name}_${value}`
	return (
		<my.Elemet data-inline={!!inline} className={className}>
			<my.RadioElement data-radio-elemet className="space-x-2">
				<my.Radio
					{...rest}
					{...(inputRef ? {ref: inputRef} : {})}
					data-inline={!!inline}
					data-invalid={!!errorMessage}
					data-valid={!!validMessage}
					defaultValue={value}
					defaultChecked={defaultValue === value}
					// checked={defaultValue === value}
					id={id}
					name={name}
					type="radio"
					className={`form-radio text-blue-500 h-4 w-4`}
				/>
				<my.Label data-invalid={!!errorMessage} data-valid={!!validMessage} data-disabled={rest.disabled} data-radio htmlFor={id}>
					<RadioIcon />
					{label}
				</my.Label>
			</my.RadioElement>
			{!!errorMessage && (<my.Error data-inline={!!inline}>{errorMessage}</my.Error>)}
			{!!validMessage && (<my.Success data-inline={!!inline}>{validMessage}</my.Success>)}
			{
				!!hint && (
					typeof hint === 'string' 
						? <my.Hint data-inline={!!inline} dangerouslySetInnerHTML={{__html: hint}} className="ml-6" />
						: <my.Hint data-inline={!!inline} className="ml-6">{hint}</my.Hint>
				)
			}
		</my.Elemet>
	)
}
Radiobox.propTypes = {
	inline: PropTypes.bool,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	defaultValue: PropTypes.any,
	hint: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	errorMessage: PropTypes.string,
	validMessage: PropTypes.string
}

const BoxCards = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    flex-shrink: 0;
		
		&[data-inline='true'] {
        display: flex;
        flex-direction: row;
		}
		
		&[data-spec-type='TabsMode'] {
        display: grid;
				grid-template-columns: repeat(3, 1fr);

        //TODO: check the media point transition
        @media all and (max-width: 1200px) {
            grid-template-columns: repeat(1, 1fr);
        }
		}
`

const BoxCard = styled.div`
    padding: 16px;
		gap: 16px;
		
    display: flex;
		flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    align-self: stretch;

    border: 1px solid transparent;
    background: var(--it-bg-cards);
		
		transition: all 0.4s;
		cursor: pointer;
		
		&[data-active='true'], &:hover:not([data-disabled='true']) {
        border: 1px solid var(--it-stroke-blue);
        background: var(--it-bg-blue);
		}
		
		&[data-disabled='true'] {
				cursor: unset;
				//TODO: check the style
				//background: var(--it-text-disabled);
		}
`

const BoxHeader = styled.div`
		width: 100%;
    display: flex;
		justify-content: space-between;
		gap: 16px;
`

const BoxContent = styled.div`
    width: 100%;
    display: flex;
		flex-direction: column;
    gap: 16px;

    &[data-spec-type='ImgCardMode'] {
        text-align: center;
    }
`

const BoxIconTitle = styled.div`
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 16px;

    &[data-spec-type='ImgCardMode'] {
        margin-left: 32px;
    }
`

const BoxIcon = styled(IconPlaceCircle)`
		svg {
				width: 16px;
				height: 16px;
		}

    &[data-type='img'] {
				width: auto;
				height: auto;
		}
`

const ItRadioIcon = styled.i`
    display: flex;
		align-items: center;
		justify-content: center;
    width: 16px;
    height: 16px;

    border-radius: 100%;
    border: 1px solid var(--it-stroke-blue);
    background: var(--it-bg-cards);
		
		&[data-checked='true'] {
        border: 1px solid var(--it-accent-blue);
        background: var(--it-accent-blue);
				
				&:before {
						content: '';
						width: 6px;
						height: 6px;
						background: #fff;
            border-radius: 100%;
				}
		}
`

const BoxTitle = styled.div`
    color: var(--it-text-white);

    /* Menu items */
    font-family: "Basis Grotesque Pro";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 19.2px */
    letter-spacing: 0.48px;
`

const BoxDescription = styled.div`
    color: var(--it-text-grey);
		//margin-top: 15px;
    /* Menu items */
    font-family: "Basis Grotesque Pro";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 19.2px */
    letter-spacing: 0.48px;
    white-space: wrap;
`

export const RadioboxCards = ({
	className = '',
	inputRef = false,
	inline = false,
	label = '',
	name = '',
	options = [],
	defaultValue = false,
	hint = '',
	errorMessage = '',
	validMessage = '',
	hideDescription = false,
	disabled = false,
	onChange = ()=>{},
	specType = '',
	...rest
}) => {
	const [value, setValue] = useState(defaultValue)
	useEffect(()=>{
		setValue(defaultValue);
	}, [defaultValue])
	let onSelect = (val)=>{
		onChange(val);
		setValue(val);
	}
	//console.log('RadioboxCards: ', {label, name, options, rest});
	return (
		<>
			<GroupBox label={label} className={`form-element ${className}`} flex={{direction: 'col'}}>
				<BoxCards data-inline={!!inline} data-spec-type={specType}>
					{options.map((option, idx)=>{
						let isActive = value === option.value;
						let isDisabled = disabled || option.disabled;
						const isTabsMode = specType === 'TabsMode';
						const _renderTitle = () => {
							return option.title ? <BoxTitle>{option.title}</BoxTitle> : null
						}
						const _renderDescription = () => {
							return option.description ? <BoxDescription>{option.description}</BoxDescription> : null
						}
						return  (
							<BoxCard key={idx}
									 onClick={()=>!isDisabled && onSelect(option.value)}
									 data-active={isActive}
									 data-disabled={isDisabled && !isActive}
									 data-spec-type={specType}
							>
								<BoxHeader>
									<BoxIconTitle data-spec-type={specType}>
										<BoxIcon data-type={option.icon?.type === 'img' ? 'img' : ''}>
											{option.icon}
										</BoxIcon>

										{isTabsMode ? _renderTitle() : null}
									</BoxIconTitle>

									<ItRadioIcon
										data-checked={isActive}
									/>
								</BoxHeader>

								<BoxContent data-spec-type={specType}>
									{!isTabsMode ? _renderTitle() : null}
									{!hideDescription ? _renderDescription() : null}
								</BoxContent>
							</BoxCard>
						)
					})}
				</BoxCards>

				{errorMessage && (
					<div className="form-error">{errorMessage}</div>
				)}
				{validMessage && (
					<div className="form-success">{validMessage}</div>
				)}
				{hint && (<div className="form-hint ml-6">{hint}</div>)}

			</GroupBox>
		</>
	)
}
RadioboxCards.propTypes = {
	className: PropTypes.string,
	inline: PropTypes.bool,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	name: PropTypes.string,
	options: PropTypes.arrayOf(PropTypes.shape({
		icon: PropTypes.element,
		title: PropTypes.string,
		description: PropTypes.string,
		value: PropTypes.string,
	})),
	defaultValue: PropTypes.any,
	hint: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	errorMessage: PropTypes.string,
	validMessage: PropTypes.string,
	hideDescription: PropTypes.bool,
	disabled: PropTypes.bool,
}

